import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { toast } from 'react-toastify';
import './AdminSocialLinks.css';

const AdminSocialLinks = () => {
  const [links, setLinks] = useState({
    telegram: '',
    x: '',
    discord: '',
    binance: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    const defaults = {
      telegram: '',
      x: '',
      discord: '',
      binance: ''
    };
    try {
      setLoading(true);
      const response = await api.get('/site-settings');
      const dataLinks = response.data.links || {};
      setLinks({
        telegram: dataLinks.telegram || defaults.telegram,
        x: dataLinks.x || defaults.x,
        discord: dataLinks.discord || defaults.discord,
        binance: dataLinks.binance || defaults.binance
      });
    } catch (error) {
      console.error('Error fetching settings:', error);
      toast.error('Failed to load social links');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const response = await api.put('/site-settings', {
        socialLinks: links
      });
      toast.success('Social links updated successfully!');
      // Refresh the settings to show updated values
      await fetchSettings();
    } catch (error) {
      console.error('Error updating settings:', error);
      const errorMessage = error.response?.data?.message || error.message || 'Failed to update social links';
      toast.error(`Failed to update social links: ${errorMessage}`);
      // Log full error for debugging
      if (error.response) {
        console.error('Response error:', error.response.data);
        console.error('Status:', error.response.status);
      }
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading social links...</div>;
  }

  return (
    <div className="admin-social-links">
      <h2>Manage Social Links</h2>
      <p className="description">Update social media links that appear in the footer</p>

      <div className="links-form">
        <div className="form-group">
          <label htmlFor="telegram">Telegram URL</label>
          <input
            type="url"
            id="telegram"
            value={links.telegram}
            onChange={(e) => setLinks({ ...links, telegram: e.target.value })}
            placeholder="https://t.me/PhoneStreamClub"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="x">X (formerly Twitter) URL</label>
          <input
            type="url"
            id="x"
            value={links.x}
            onChange={(e) => setLinks({ ...links, x: e.target.value })}
            placeholder="https://x.com/PhoneStreamClub"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="discord">Discord URL</label>
          <input
            type="url"
            id="discord"
            value={links.discord}
            onChange={(e) => setLinks({ ...links, discord: e.target.value })}
            placeholder="https://discord.gg/uqk9yysW8B"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="binance">Binance URL</label>
          <input
            type="url"
            id="binance"
            value={links.binance}
            onChange={(e) => setLinks({ ...links, binance: e.target.value })}
            placeholder="https://binance.com/en/trade/..."
            className="form-input"
          />
        </div>

        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Saving...' : 'Save Social Links'}
        </button>
      </div>
    </div>
  );
};

export default AdminSocialLinks;
